class Analytics {
    //localData = [];
    //reloadingAds = false;

    //local(event, data = {}) {
    // if (app.util.getCookie("localData").length === 0) {
    //     this.localData = [];
    // }
    // if (!sessionStorage.hasOwnProperty("uidk")) {
    //     sessionStorage.setItem("uidk", Math.round(999999999999999999 * Math.random()) + "");
    //     this.localData.push({event: "setSession", sess: sessionStorage.getItem("uidk"), ref: document.referrer, url: document.location.pathname, host: document.location.host});
    // }
    // this.localData.push({event: event, data: data, sess: sessionStorage.getItem("uidk"), url: document.location.pathname});
    // app.util.setCookie("localData", JSON.stringify(this.localData), 86000);
    //}

    umami(action, data = {}) {
        // if (typeof umami === "object") {
        //     umami.track(action, data);
        // }
    }

    google(action, data = {}) {
        // if (typeof gtag === "function") {
        //     gtag('event', action, data);
        // }
    }

    facebook(action, data = {}) {
        if (typeof fbq === "function") {
            fbq('track', action, data);
        }
    }

    microsoft(action, data = {}) {
        // if (typeof window.uetq === "object") {
        //     window.uetq.push("event", action, data);
        // }
    }

    track(action, data = {}) {
    }

    reset() {
    }

    optOut() {
        app.util.deleteAllCookies();
        app.storage.clean();
    }

    init(config) {
    }

    pageView() {
        //this.google("page_view", {'page_location': window.location.href});
        this.facebook('PageView');
    }

    linkOut(goto) {
        this.track('link_out', {'goto': goto});
    }

    userCreated(id, username) {
        this.facebook('CompleteRegistration');
        // this.google("sign_up");
        //this.microsoft("signup");
    }

    userLogin() {
        this.track("log_in");
    }

    userLogout() {
        this.track("log_out");
        this.reset();
    }

    userVip(price, currency) {
        this.facebook('Subscribe', {value: price, currency: currency, predicted_ltv: '0.00'});
    }

    checker(limit = 300) {
        if (limit <= 0) {
            return;
        }
        setTimeout(() => {
            $(".arender").each(function () {
                let sda = $(this).find("div").first();
                if (sda.height() > 1 && sda.css("display") !== "hidden") {
                    $(this).parent().parent().find(".gevip").css({
                        bottom: "100%"
                    });
                    $(this).parent().parent().find(".backup").css({display: "none"});
                } else {
                    if (limit === 295) {
                        $(this).parent().parent().find(".backup").css({display: "block"});
                        $(this).parent().parent().find(".gevip").css({
                            bottom: "100%"
                        });
                    }
                }
            });
            this.checker(limit - 1);
        }, 3000);
    }

    insertOverlayAd(parent = "#playgame-content-wrapper", timeInS = 10, name = "game_play") {
        if (app.config.user === undefined || !app.config.user.v) {
            let parentElement = $(parent);
            if (parentElement.length) {
                app.ajax.get("/services/layout/page/ads/game_play_overlay", {"timeInS": timeInS, "name": name}, function (data) {
                    if (data.html) {
                        let old = parentElement.find(".reka");
                        if (old.length) {
                            old.remove();
                        }
                        parentElement.append(data.html);
                        if (parent === "#app") {
                            parentElement.find(".reka").css("position", "fixed");
                        }
                        app.analytics.checker();
                    }
                }, null, false);
            }
        }
    }

    getAdSizes(id, style = "horizontal") {
        let game = [[1024, 768], [768, 1024], [970, 250], [580, 400], [750, 300], [750, 200], [980, 120], [580, 400], [480, 320], [300, 600], [336, 280], [300, 250], [300, 100], [250, 360], [250, 250], [240, 400], [200, 200], [180, 150], [160, 600], [120, 600], [120, 240]];
        let horizontal = [[970, 250], [930, 180], [750, 300], [750, 200], [980, 120], [980, 90], [970, 90], [960, 90], [950, 90], [750, 100], [728, 90], [336, 280], [300, 100], [300, 250], [300, 600], [250, 250], [160, 600]]
        let vertical = [[336, 280], [300, 100], [300, 250], [300, 600], [250, 250], [160, 600]];
        let width = document.getElementById(id).offsetWidth;
        let height = window.innerHeight - 120;
        let list = ['fluid'];
        let source;
        switch (style) {
            case "horizontal":
                source = horizontal;
                break;

            case "game":
                source = game;
                break;

            case "vertical":
                source = vertical;
                break;
        }
        let index = 1;
        for (let i in source) {
            if (source[i][0] <= width && source[i][1] <= height) {
                list[index++] = source[i];
            }
        }
        return list;
    }
}